import App from 'app/app.js';

function AddressConsistencyService(ShoppingCartStore, ContentStore, ErrorLogService, $location) {
  var SHIPPING_ADDRESS_SYNC = {
    name: 'Shipping',
    fields: ['firstName', 'lastName', 'email', 'streetAddress', 'city', 'stateProvince', 'postalCode', 'phoneNumber'],
    getStoredAddress: function () {
      return ShoppingCartStore.getShippingAddress();
    },
    syncToStore: function (shippingAddress) {
      ShoppingCartStore.setShippingAddress(shippingAddress);
    }
  };
  var BILLING_ADDRESS_SYNC = {
    name: 'Billing',
    fields: ['firstName', 'lastName', 'email', 'streetAddress', 'city', 'stateProvince', 'postalCode'],
    getStoredAddress: function () {
      return ShoppingCartStore.payment.billingAddress;
    },
    syncToStore: function (billingAddress) {
      ShoppingCartStore.setBillingAddress(billingAddress);
    }
  };

  var PO_BOX_REGEX = /\bP\.?\s*?O\.?\s*?Box\d*\b/i;
  var PO_BOX_RESTRICTED_STATES = (
    ContentStore.getContent('MOBILE_TRANS_BILLING_INFO', 'BILLING_INFO_RESTRICTED_STATES_FOR_PO_BOX') || ''
  ).split(',');

  this.syncToStore = function (submittedShippingAddress, submittedBillingAddress) {
    var shippingAddressSynced = true;
    if (ShoppingCartStore.hasShippingAddress()) {
      shippingAddressSynced = this._syncToStore(SHIPPING_ADDRESS_SYNC, submittedShippingAddress);
    }
    var billingAddressSynced = this._syncToStore(BILLING_ADDRESS_SYNC, submittedBillingAddress);

    return shippingAddressSynced && billingAddressSynced;
  };

  this._syncToStore = function (sync, submittedAddress) {
    var storedAddress = sync.getStoredAddress();

    var message = $location.path() + ', ' + sync.name + ' Details Missing - ';

    if (!storedAddress) {
      storedAddress = {};
      message += 'object null,';
    }

    var fields = this._inspectFieldPresence(sync, submittedAddress, storedAddress);

    fields.found.forEach(function (field) {
      storedAddress[field] = submittedAddress[field];
    });

    if (fields.found.length && !fields.missing.length) {
      sync.syncToStore(storedAddress);
    }

    if (fields.missing.length || fields.found.length) {
      ErrorLogService(
        new Error(message + 'Found: ' + fields.found.join(',') + '; ' + 'Missing: ' + fields.missing.join(','))
      );
    }

    return fields.missing.length === 0;
  };

  this._inspectFieldPresence = function (sync, submittedAddress, storedAddress) {
    var fields = {
      found: [],
      missing: []
    };

    sync.fields.forEach(function (field) {
      if (!storedAddress[field]) {
        if (submittedAddress && submittedAddress[field]) {
          fields.found.push(field);
        } else {
          fields.missing.push(field);
        }
      }
    });

    return fields;
  };

  this.isAddressRestricted = function (stateProvince, address) {
    return (
      !!stateProvince &&
      !!address &&
      PO_BOX_RESTRICTED_STATES.includes(stateProvince.description) &&
      PO_BOX_REGEX.test(address)
    );
  };
}

App.service('AddressConsistencyService', [
  'ShoppingCartStore',
  'ContentStore',
  'ErrorLogService',
  '$location',
  AddressConsistencyService
]);
